import { useState } from 'react'
import styles from './MobileLanguageSwitch.module.scss'

function MobileLanguageSwitch() {
  const [currentLanguage, setCurrentLanguage] = useState('pl')

  const handleLanguageChange = (lang: string) => {
    if (currentLanguage !== lang) {
      setCurrentLanguage(lang)
    }
  }

  return (
    <div className={styles.styledLanguageSwitch}>
      <button
        className={`body-bold-medium ${styles.styledLanguageButton} ${
          currentLanguage === 'pl' ? styles.styledLanguageButtonSelected : ''
        }`}
        onClick={() => handleLanguageChange('pl')}
        type="button"
      >
        Pl
      </button>
      <button
        className={`body-bold-medium ${styles.styledLanguageButton} ${
          currentLanguage === 'en' ? styles.styledLanguageButtonSelected : ''
        }`}
        onClick={() => handleLanguageChange('en')}
        type="button"
      >
        En
      </button>
    </div>
  )
}

export default MobileLanguageSwitch
